import { render } from "./MasterLayout.vue?vue&type=template&id=0ccdb056&scoped=true"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"

import "./MasterLayout.vue?vue&type=style&index=0&id=0ccdb056&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccdb056"]])

export default __exports__